export default function EditTwoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
    >
      <path
        d="M4.75 14.1874H1.375C1.22582 14.1874 1.08274 14.1282 0.977253 14.0227C0.871763 13.9172 0.8125 13.7741 0.8125 13.6249V10.4829C0.8125 10.409 0.827049 10.3359 0.855318 10.2677C0.883586 10.1994 0.92502 10.1374 0.977253 10.0852L9.41475 1.64766C9.52024 1.54217 9.66332 1.48291 9.8125 1.48291C9.96168 1.48291 10.1048 1.54217 10.2102 1.64766L13.3523 4.78967C13.4577 4.89516 13.517 5.03823 13.517 5.18741C13.517 5.3366 13.4577 5.47967 13.3523 5.58516L4.75 14.1874ZM4.75 14.1874H13.1875M4.75 14.1874L0.848289 10.2857M7.5625 3.49991L11.5 7.43741"
        stroke="#DC3545"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
